import { render, staticRenderFns } from "./CallFeeExport.vue?vue&type=template&id=54c5bd98"
import script from "./CallFeeExport.vue?vue&type=script&lang=js"
export * from "./CallFeeExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports